module.exports = __webpack_public_path__ + "img/icon-group11.b771293e.png";